import React from 'react';

import Card from '/component/base/Card';
import Text from '/component/base/Text';
import {HealthJourneyTestIds} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './ClientPlan.style';

interface ClientPlanProps {
  planDetails: {
    name: string;
    shortDescription: string;
  };
}

export const ClientPlan: React.FC<ClientPlanProps> = ({
  planDetails = {
    name: '',
    shortDescription: '',
  },
}) => {
  const {ts} = useTranslation('component.partial.clientplan');

  const formatShortDescription = (description: string) => {
    const parts = description.split(/<b>OPTA<\/b>/);
    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && (
              <Text isBold style={styles.optaText}>
                OPTA
              </Text>
            )}
          </React.Fragment>
        ))}
      </>
    );
  };
  const formatName = (name: string) => {
    const parts = name.split(/(<b>OPTA<\/b>|VIA)/);
    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part === '<b>OPTA</b>' ? (
              <Text isBold style={styles.optaTextName}>
                OPTA
              </Text>
            ) : part === 'VIA' ? (
              <Text style={styles.optaTextName}>VIA</Text> // No isBold here
            ) : (
              part
            )}
          </React.Fragment>
        ))}
      </>
    );
  };
  return (
    <Card style={styles.cardContainer}>
      <Text
        isBold
        style={styles.titleText}
        {...testProperties(HealthJourneyTestIds.clientPlan)}>
        {planDetails?.name ? (
          formatName(ts('title.clientPlan', `${planDetails?.name}`))
        ) : (
          <Text
            isBold
            style={styles.titleText}
            {...testProperties(HealthJourneyTestIds.clientPlan)}>
            {ts('title.clientPlan', 'No plan')}
          </Text>
        )}
      </Text>

      <Text
        style={styles.description}
        {...testProperties(HealthJourneyTestIds.clientPlanDescription)}>
        {planDetails?.shortDescription ? (
          formatShortDescription(
            ts('title.planDescription', `${planDetails?.shortDescription}`),
          )
        ) : (
          <Text
            style={styles.description}
            {...testProperties(HealthJourneyTestIds.clientPlanDescription)}>
            {ts('title.planDescription', 'Client has not selected their ')}
            <Text isBold style={styles.optaText}>
              OPTA
            </Text>
            <Text>VIA plan.</Text>
          </Text>
        )}
      </Text>
    </Card>
  );
};

export default ClientPlan;
